import { observer } from "mobx-react";
import { ConfirmDialog, ConfirmDialogProps } from "primereact/confirmdialog";
import React from "react";
import { useLocStore } from "../../localization";
import { LocContext } from "../../localization/LocContext";
import { pluginComponentStore } from "../../utils/PluginComponents";
import { concatClassnames } from "../../utils/util";

export interface WsConfirmDialogProps extends ConfirmDialogProps {
  useProps?: (props: WsConfirmDialogProps) => WsConfirmDialogProps;
}

export function wsConfirmDialog(
  props: WsConfirmDialogProps
): Promise<boolean | null> {
  return new Promise((r) => {
    let resolve = (result: boolean | null) => {
      pluginComponentStore.remove(dialogId);
      r(result);
    };

    const { className, ...rest } = props;

    const dialog = observer(() => {
      const L = useLocStore(LocContext.GENERAL);

      const useProps = props.useProps ?? ((p) => p);

      const defaultProps = {
        visible: true,
        rejectLabel: L.id("187681e35381").loc("Nei"),
        acceptLabel: L.id("d9fed4f5b386").loc("Ja"),
        accept: () => resolve(true),
        reject: () => resolve(false),
        onHide: () => resolve(null),
        className: concatClassnames([
          className,
          "cvp-confirmation-dialog",
          !rest.icon && "cvp-confirmation-dialog-no-icon",
        ]),
        ...rest,
      };

      const { useProps: _, ..._finalProps } = useProps(defaultProps);

      return (
        <ConfirmDialog
          style={{ width: "50vw" }}
          breakpoints={{ "960px": "80vw", "641px": "90vw" }}
          {..._finalProps}
        />
      );
    });
    const dialogId = pluginComponentStore.add(dialog);
  });
}
